// @ts-check
import { LBButton } from '@linearb/buzz';
import { FLOW_TRACKER_INSIGHT_STATUS } from '@linearb/linjs-common';
import {
  DeliveryIcon,
  lightColorPalette,
  NewIcon,
  Tooltip
} from '@linearb/linui-common';
import { Body1 } from '@linearb/linui-common/typography';
import { Stack } from '@mui/material';
import {
  buttonTooltipTitles,
  NO_ACVTIVITY_FOUND
} from 'components/IterationSummary/IterationSummary.consts';
import useIterationSummaryEventsTracker from 'components/IterationSummary/useIterationSummaryEventsTracker';
import SearchInput from 'components/SearchInput';
import { useMemo } from 'react';
import { useHistory } from 'react-router';

const HeaderForRetrospectPulseView = ({
  searchValue,
  setSearchValue,
  iterationSummary
}) => {
  const history = useHistory();

  const trackingEventsHandler = useIterationSummaryEventsTracker({
    insightId: iterationSummary?.data?.insight_id
  });

  const onOpenIterationSummary = () => {
    const seachParams = new URLSearchParams(window.location.search);
    seachParams.set('iteration_summary', 'true');
    history.push({ search: seachParams.toString() });
    trackingEventsHandler.onOpen();
  };

  const onHoverIterationSummary = () => {
    trackingEventsHandler.onViewButtonHover();
  };

  const disabledSummaryButton = useMemo(() => {
    return (
      iterationSummary?.isLoading ||
      !iterationSummary?.data ||
      iterationSummary?.data?.accomplishments?.length === 0 ||
      iterationSummary?.status !== FLOW_TRACKER_INSIGHT_STATUS.INSIGHT_CREATED
    );
  }, [iterationSummary]);

  return (
    <Stack
      gap={theme => theme.spacing(2)}
      padding={theme => theme.spacing(2.75)}
    >
      <Stack flexDirection='row' justifyContent='space-between'>
        <Stack
          gap={theme => theme.spacing(1)}
          flexDirection='row'
          alignItems='center'
        >
          <DeliveryIcon color={lightColorPalette.lbTextSubdued} />
          <Body1>Delivery breakdown</Body1>
        </Stack>
        <Tooltip
          disableHoverListener={!disabledSummaryButton}
          title={
            <span
              dangerouslySetInnerHTML={{
                __html:
                  buttonTooltipTitles[iterationSummary?.status] ||
                  NO_ACVTIVITY_FOUND
              }}
            />
          }
        >
          <div>
            <LBButton
              disabled={disabledSummaryButton}
              onClick={onOpenIterationSummary}
              onMouseEnter={onHoverIterationSummary}
            >
              <NewIcon />
              View AI Iteration Summary
            </LBButton>
          </div>
        </Tooltip>
      </Stack>
      <Stack paddingRight={theme => theme.spacing(2)}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          height='2.8rem'
          placeholder='Search tasks'
        />
      </Stack>
    </Stack>
  );
};

export default HeaderForRetrospectPulseView;
